import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import configureStore from "./config/configureStore";
import { scheduleGuideJarWidget } from "./utils/loadGuideJarWidget";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("./firebase-messaging-sw.js")
    .then(function (registration) {
      console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(function (err) {
      console.log("Service worker registration failed, error:", err);
    });
}
ReactDOM.render(
  <GoogleOAuthProvider clientId="307069868807-nmk5bv2ol3c8aa08fptb6cu081ui2ko8.apps.googleusercontent.com">
    <Provider store={configureStore}>
      <App />
    </Provider>
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

scheduleGuideJarWidget();
